export const isValidMaskId = id => {
  return (
    isNumeric(id) && Number(id) >= 0 && Number(id) < 16384 && !isMinusZero(id)
  );
};

const isNumeric = n => {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

function isMinusZero(value) {
  return 1 / value === -Infinity;
}
